<script lang="ts">
export const progressCls = cva("progress", {
	variants: {
		color: {
			default: null,
			neutral: "progress-neutral",
			primary: "progress-primary",
			secondary: "progress-secondary",
			accent: "progress-accent",
			success: "progress-success",
			warning: "progress-warning",
			error: "progress-error",
		},
	},
});

type variant = VariantProps<typeof progressCls>;

export interface ProgressProps extends ClassProps {
	color?: variant["color"];
}

interface Props
	extends ProgressProps,
		/* @vue-ignore */ Omit<ProgressHTMLAttributes, keyof ProgressProps> {}
</script>

<script setup lang="ts">
import { cva, type VariantProps } from "class-variance-authority";
import { useAttrs, type ProgressHTMLAttributes } from "vue";
import { type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

const props = defineProps<Props>() as ProgressProps;
const attrs = useAttrs() as ProgressHTMLAttributes;
</script>

<template>
	<progress :class="cn(progressCls(props))" max="100" v-bind="attrs" />
</template>
